export default "__VITE_ASSET__5gljhyDJ__"